exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sV5f8Nh6QfBt0x3SCYaJo{position:absolute;bottom:5px;right:5px}", ""]);

// exports
exports.locals = {
	"aboutLink": "sV5f8Nh6QfBt0x3SCYaJo"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/about/style.css
 ** module id = 345
 ** module chunks = 0
 **/